const FADE = 'linear-gradient(to bottom, black 60%, transparent)'

/**
 * Clamp long WYSIWYG content to a number of lines with a "Read more" toggle.
 *
 * Markup: [data-read-more data-lines="6"] wrapping [data-read-more-content]
 * and a hidden [data-read-more-toggle] button. The button only shows when the
 * content actually overflows the clamp.
 */
export default function initReadMore() {
	document.querySelectorAll('[data-read-more]').forEach(el => {
		const content = el.querySelector('[data-read-more-content]')
		const toggle = el.querySelector('[data-read-more-toggle]')
		if (!content || !toggle) return

		const lines = parseInt(el.dataset.lines, 10) || 6
		let expanded = false

		const setFade = on => {
			content.style.maskImage = on ? FADE : ''
			content.style.webkitMaskImage = on ? FADE : ''
		}

		const getCollapsedHeight = () => {
			const textEl = content.firstElementChild || content
			const lineHeight = parseFloat(getComputedStyle(textEl).lineHeight) || 24
			return lineHeight * lines
		}

		const measure = () => {
			if (expanded) return
			content.style.transition = ''
			content.style.maxHeight = ''
			const collapsed = getCollapsedHeight()
			const overflows = content.scrollHeight > collapsed + 4

			toggle.hidden = !overflows
			setFade(overflows)
			content.style.maxHeight = overflows ? `${collapsed}px` : ''
		}

		toggle.addEventListener('click', () => {
			expanded = !expanded
			toggle.setAttribute('aria-expanded', String(expanded))
			toggle.textContent = expanded ? 'Read less' : 'Read more'

			content.style.transition = 'max-height 0.5s ease'
			if (expanded) {
				setFade(false)
				content.style.maxHeight = `${content.scrollHeight}px`
			} else {
				content.style.maxHeight = `${content.scrollHeight}px`
				content.offsetHeight // force reflow so the collapse animates
				content.style.maxHeight = `${getCollapsedHeight()}px`
				setFade(true)
			}
		})

		content.addEventListener('transitionend', () => {
			if (expanded) content.style.maxHeight = 'none'
		})

		measure()
		let resizeTimer
		window.addEventListener('resize', () => {
			clearTimeout(resizeTimer)
			resizeTimer = setTimeout(measure, 200)
		})
	})
}
